/** Runtime config injected by config.js (generated at deploy from stack
 *  outputs / SSM). See web/build.mjs and the stack README. */
export interface PortalConfig {
    userPoolId: string;
    userPoolClientId: string;
    region: string;
    /** Same-origin base for the Tickets API (CloudFront proxies /tickets/V1/*). */
    apiBase: string;
    intercomAppId: string;
    /** Where to send a signed-in customer — the Intercom Help Center portal. */
    helpCenterUrl: string;
    /** Where to send a signed-in partner — the partner Help Center (same workspace). */
    partnerHelpCenterUrl: string;
    /** Insights app login, used by the "Sign in as Partner" button. */
    insightsUrl: string;
}

declare global {
    interface Window {
        PORTAL_CONFIG: PortalConfig;
    }
}

export const config: PortalConfig = window.PORTAL_CONFIG;
